/**
 * Тип-стрічки для дій над рядком таблиці (`onSelectRow(record, type)`).
 *
 * Значення `BUSINESS_ACCOUNT` та `DASHBOARD` **не змінювати** — вони приходять
 * з shared `getBaseColumns` (`src/Components/Table/baseColumns.js`), який
 * hardcode-ить ці рядки як ключі меню Business account cell (§8.1).
 * Решта — Receipt-специфічні (див. §6, §6.1).
 */
export const ROW_ACTIONS = Object.freeze({
  BUSINESS_ACCOUNT: "business_account",
  DASHBOARD: "dashboard",
  PROFILE_DETAILS: "profile_details",
  ADD_COMMENT: "add_comment",
  ARCHIVE: "archive",
  DELETE: "delete",
  USER_BALANCE: "user_balance"
})
